import type { ReceiptTemplate } from '../schema';

export const venmoTemplate: ReceiptTemplate = {
  id: 'venmo',
  name: 'Venmo Receipt',
  brand: 'VENMO',
  description: 'Mobile payment receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'venmo-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 120,
        logoHeight: 50,
        businessName: 'Venmo',
        businessNameFontSize: 24,
        addressLines: [
          'Payment Confirmation',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'venmo-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'You paid @JamesSullivan',
        fontSize: 14,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'venmo-amount',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '$75.00',
        fontSize: 28,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'venmo-note',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '"Dinner last night 🍕"',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'venmo-details',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Date: January 4, 2026\nTime: 8:42 PM\n\nTransaction ID:\n3847291847291ABCD\n\nFrom: @MikeWazowski\nTo: @JamesSullivan',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'venmo-funding',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Funding Source:\nVenmo Balance',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'venmo-status',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '✓ Payment Complete',
        fontSize: 14,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: true,
      },
    },
  ],
};

